import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import TabContainer from '@/components/common/TabContainer';
import ViewIcon from '@/components/Icons/ViewIcon';
import Layout from '@/components/Layout/Layout';
import ApproveModal from '@/components/Modal/ApproveModal';
import useFilter from '@/hooks/useFilter';
import { IDeleteResponse } from '@/interfaces/common.model';
import { IAttendanceRegularizationResponse } from '@/interfaces/regularization.model';
import { RootState } from '@/redux/store';
import {
  getFilterUrl,
  orderByList,
  showToastNotification,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
interface IPageStates {
  currentPage: number;
  pageSize: number;
  count: number;
  totalPages: number;
  searchQuery: string;
  tableLoader: boolean;
  aRStatus: string;
  leaveType: string;
  sortByDate: string[] | string;
  officeName: string;
  user: string;
}
export interface IArTableData {
  selectAll?: string;
  id: string;
  index: number;
  empNameWithImage: string;
  officeName: string;
  siteName?: string;
  appliedOn: string;
  startDate: string;
  endDate: string;
  checkInTime?: string;
  checkOutTime?: string;
  attendanceStatus?: number;
  status?: number;
}
interface IData {
  arList: IArTableData[] | null;
  userList: unknown;
}
const TeamRegularization = () => {
  const navigate = useNavigate();
  const filterDetails = useSelector(
    (state: RootState) => state.user?.filtersStates,
  );
  const [data, setData] = useState<IData>({
    arList: null,
    userList: null,
  });
  const [pageStates, setPageStates] = useState<IPageStates>({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: '',
    tableLoader: false,
    aRStatus: '',
    leaveType: '',
    sortByDate: [
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD'),
    ],
    officeName: '',
    user: '',
  });
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  // const [isCheckedAll, setIsCheckedAll] = useState<boolean>(false);
  const [actionType, setActionType] = useState<string>('');
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  console.log('SetSelectedIDS: ', selectedIds);

  // const handleSelection = (id: string) => {
  //   setSelectedIds((prev) =>
  //     prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
  //   );
  //   setIsCheckedAll(false);
  // };

  // const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.checked && data?.arList) {
  //     const ids = data?.arList
  //       ?.filter((item) => item?.status === 0)
  //       ?.map((item) => item?.id);
  //     setSelectedIds(ids);
  //     setIsCheckedAll(!isCheckedAll);
  //   } else {
  //     setSelectedIds([]);
  //     setIsCheckedAll(false);
  //   }
  // };

  const actionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      isShow: 'always',
      clickHandler: (data: IArTableData) => {
        navigate(`${RoutesLink.arTeamRequestDetail}/${data?.id}`);
      },
    },
  ];
  const getArRequest = async () => {
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    const filter = {
      search: pageStates.searchQuery,
      orderBy: filterDetails?.orderBy,
      startDate: pageStates?.sortByDate[0],
      endDate: pageStates?.sortByDate[1],
    };
    try {
      const res: IAttendanceRegularizationResponse = await callApi(
        API_URL + API_ENDPOINT.getAr + '?' + getFilterUrl(filter),
        { method: 'GET' },
      );
      console.log(res);
      if (res?.status === true) {
        const newData = res?.data?.attendance?.map((item, index) => ({
          ...item,
          index: index,
          empNameWithImage: item?.user?.name + '##' + item?.user?.profilePhoto,
          officeName: item?.user?.site?.name ?? '--',
          //   siteName: item?.user?.usersites?.[0]?.site?.name,
          appliedOn: moment(item?.createdAt).format('DD/MM/YYYY'),
          startDate: moment(item?.checkInTime).format('DD/MM/YYYY'),
          endDate: moment(item?.checkOutTime).format('DD/MM/YYYY'),
          checkInTime:
            item.checkInTime && moment.utc(item.checkInTime).format('hh:mm A'),
          checkOutTime:
            item.checkOutTime &&
            moment.utc(item.checkOutTime).format('hh:mm A'),
          attendanceStatus: item?.status,
          status: item?.arRequestStatus,
        }));

        setData((pre) => ({
          ...pre,
          arList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total ?? 0,
        }));
      } else {
        showToastNotification('danger', res?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  };

  // const getSiteUser = (type, siteName) => {
  //   const option = {
  //     method: "GET",
  //   };
  //   const url =
  //     type === "office"
  //       ? apiUrl.get_office + `?officeId=${siteName}`
  //       : apiUrl.site_users + `?siteId=${siteName}`;
  //   callApi(url, option).then((res) => {
  //     if (res?.status === true) {
  //       setData((pre) => ({ ...pre, userList: res.data?.user || res?.data }));
  //       setPageStates((pre) => ({
  //         ...pre,
  //         ...(type === "office"
  //           ? { officeName: siteName }
  //           : { siteId: siteName }),
  //       }));
  //     } else {
  //       toast.error(res?.message);
  //     }
  //   });
  // };

  // const GetOfficeList = () => {
  //   getSiteUser("office", userDetails?.officeId);
  // };

  const TableHeadingOffice: ITableColumn<IArTableData>[] = [
    // {
    //   value: 'selectAll',
    //   label: (
    //     <input
    //       className="form-check-input"
    //       type="checkbox"
    //       checked={!!isCheckedAll}
    //       onChange={handleSelectAll}
    //     />
    //   ),
    // },
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'officeName', label: 'Office' },
    { value: 'appliedOn', label: 'Created On' },
    { value: 'startDate', label: 'Start Date' },
    { value: 'endDate', label: 'End Date' },
    { value: 'checkInTime', label: 'Check In' },
    { value: 'checkOutTime', label: 'Check Out' },
    { value: 'attendanceStatus', label: 'Attendance' },
    { value: 'status', label: 'Status' },
  ];

  useEffect(() => {
    getArRequest();
  }, [
    pageStates?.sortByDate,
    pageStates?.currentPage,
    pageStates.user,
    pageStates?.searchQuery,
    pageStates?.aRStatus,
    pageStates.pageSize,
    filterDetails?.orderBy,
  ]);

  // useEffect(() => {
  //   if (
  //     pageStates.activeTab === 1 &&
  //     checkUserAccess(userDetails).isUserAccess &&
  //     !pageStates.officeName
  //   ) {
  //     GetOfficeList();
  //   }
  // }, [pageStates.officeName]);

  const dateChangeHandler = (Dates: Date[]) => {
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: '' }));
    }
  };
  const handleApproveReject = async (type: string, reason?: string) => {
    try {
      setIsUpdating(true);
      let status;
      if (type === 'approve') {
        status = 1;
      } else if (type === 'reject') {
        status = 2;
      }
      const submitData = {
        type: 'arRequest',
        id: selectedIds.length === 1 ? selectedIds[0] : selectedIds,
        status: status,
        ...(reason && {
          reason: reason,
        }),
      };
      console.log(submitData);
      const API = API_URL + API_ENDPOINT?.userStatusUpdate;
      const response: IDeleteResponse = await callApi(API, {
        method: 'POST',
        data: submitData,
      });
      if (response?.status === true) {
        showToastNotification('success', response?.message);
        setConfirmationModal(false);
        setSelectedIds([]);
        getArRequest();
      } else {
        showToastNotification('danger', response?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdating(false);
    }
  };

  const confirmation = (actionType?: string, reason?: string) => {
    if (actionType === 'approve') {
      handleApproveReject(actionType);
    } else if (actionType === 'reject') {
      handleApproveReject(actionType, reason);
    }
  };

  const {
    pageChangeHandler,
    handleChangePageSize,
    handleSearchChange,
    orderByHandler,
  } = useFilter(pageStates, setPageStates);

  const handleApprove = () => {
    setConfirmationModal(true);
    setActionType('approve');
  };
  const handleReject = () => {
    setConfirmationModal(true);
    setActionType('reject');
  };

  return (
    <>
      <Layout>
        <div className="content">
          <MainHeading
            title={'Team Regularization Request'}
            dateChangeHandler={dateChangeHandler}
            showDefaultDate={true}
          />
          <>
            <TabContainer>
              <FilterComponent
                handleSearch={handleSearchChange}
                //   filterArray={sortListSite}
                //   pageState={pageStates}
                // leaveList={state?.siteList}
                //   handleData={handleData}
                //   sortHandler={handleData}
                orderByHandler={orderByHandler}
                orderByList={orderByList}
                isGrid={false}
                //   tableDataForExport={state?.aRList}
                exportFileName={'Team_AR_Request_Data'}
                exportColumns={[
                  'employeeName',
                  'officeName',
                  'appliedOn',
                  'startDate',
                  'endDate',
                  'checkIn',
                  'checkOut',
                  'leaveStatus',
                  'arRequestStatus',
                ]}
              />
              <CommonTable<IArTableData>
                ActionData={actionData}
                tableHeading={TableHeadingOffice}
                tableData={data?.arList ?? []}
                currentPage={pageStates?.currentPage}
                pageChangeHandler={pageChangeHandler}
                isLoading={pageStates?.tableLoader}
                totalPages={pageStates?.totalPages}
                count={pageStates?.count}
                handleChangePageSize={handleChangePageSize}
                pageSize={pageStates?.pageSize}
                selectedIds={selectedIds}
                // handleSelection={handleSelection}
                isSelectionDisabled={(data) => data.status !== 0}
                handleApprove={handleApprove}
                handleReject={handleReject}
              />
            </TabContainer>
          </>
        </div>
      </Layout>
      {confirmationModal && (
        <ApproveModal
          isOpen={confirmationModal}
          toggle={() => setConfirmationModal(false)}
          submitHandler={confirmation}
          actionType={actionType}
          isLoading={isUpdating}
        />
      )}
    </>
  );
};
export default TeamRegularization;
